export const ModalBoxStyle = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90vw',
	maxWidth: '280px',
	bgcolor: '#ffffff',
	borderRadius: '8px',
	boxShadow: 8,

	p: 2,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
};

export const ModalBoxStyleLarge = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90vw',
	// maxWidth: '280px',
	bgcolor: '#ffffff',
	borderRadius: '8px',
	boxShadow: 8,

	p: 2,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
};

export const FullscreenModalBoxStyle = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '120vw',
	height: '120vh',
	bgcolor: '#ffffff',

	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
};

export const ModelBackBtnStyle = {
	position: 'absolute' as 'absolute',
	top: '0',
	left: '0',
	width: '56px',
	height: '56px',
	padding: '16px',
};

export const ModalBoxInnerStyle = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90vw',
	maxWidth: '300px',
	bgcolor: '#ffffff',
	borderRadius: '6px',
	boxShadow: 8,
};
